var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-component-holder"},[_c('div',{staticClass:"row row-scheduler"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"panel-body"},[(_vm.def)?_c('map-block',{attrs:{"item":_vm.def}}):_vm._e()],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }